<template>
  <div id="app" class="main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    var html = document.querySelector('html');
    var start = new Date('2020-04-04 00:00:00').getTime(),
        end = new Date('2020-04-05 00:00:00').getTime(),
        now = new Date().getTime();
    if (now >= start && now <= end) {
      html.style.filter = 'grayscale(1)';
      html.style.webkitFilter = 'grayscale(1)';
      html.style.mozFilter = 'grayscale(1)';
      html.style.msFilter = 'grayscale(1)';
      html.style.oFilter = 'grayscale(1)';
    } else {
      html.style.filter = 'grayscale(0)';
      html.style.webkitFilter = 'grayscale(0)';
      html.style.mozFilter = 'grayscale(0)';
      html.style.msFilter = 'grayscale(0)';
      html.style.oFilter = 'grayscale(0)';
    }
  }
}
</script>

<style>
  html,body{
    width: 100%;
    height: 100%;
    background-color:#f5f5f5;
  }
  .main{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue